import { render } from "./NcrmWorkflowFileImportDialog.vue?vue&type=template&id=25f0b2b8&scoped=true"
import script from "./NcrmWorkflowFileImportDialog.vue?vue&type=script&lang=js"
export * from "./NcrmWorkflowFileImportDialog.vue?vue&type=script&lang=js"

import "./NcrmWorkflowFileImportDialog.vue?vue&type=style&index=0&id=25f0b2b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25f0b2b8"]])

export default __exports__